import bService from './base-api'
import { CONTRACT_MANAGER_URL } from '../configs/service-url'

const changeCompany = async (companyCode) => {
  const url = CONTRACT_MANAGER_URL.CHANGE_COMPANY
  const data = {
    companyCode: companyCode
  }
  const result = await bService.post(url, data)

  return result
}

export default {
  changeCompany
}
